// Helpers de lançamentos financeiros — verdade única reusada por FinanceiroPage,
// ContasListPage e DashboardPage. Antes estavam inline em FinanceiroPage.

// Calcula o saldo restante de um lançamento financeiro.
// - Sem parcelas: saldo = valor se status != Pago, senão 0.
// - Com parcelas: soma das parcelas NÃO pagas (pagas já abateram o saldo).
export function saldoRestante(f) {
  if (!f.parcelas || f.parcelas.length === 0) {
    return f.status === 2 ? 0 : Number(f.valor) || 0;
  }
  return f.parcelas
    .filter((p) => !p.pago)
    .reduce((a, p) => a + (Number(p.valor) || 0), 0);
}

// Parse manual de string ISO "YYYY-MM-DD" → Date local (00:00 no fuso do browser).
// Evita o drift UTC do new Date("YYYY-MM-DD") que pode deslocar o dia em fusos ao oeste.
export function parseLocalDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

// Dias de atraso em relação a hoje. Positivo = vencido (X dias atrás).
// Zero = vence hoje. Negativo = ainda no futuro. null = sem vencimento.
export function diasAtraso(iso) {
  const v = parseLocalDate(iso);
  if (!v) return null;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  v.setHours(0, 0, 0, 0);
  return Math.floor((hoje.getTime() - v.getTime()) / 86400000);
}
